import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ title, children }) => {
  return (
    <div
      className="min-h-screen"
      style={{ background: 'radial-gradient(ellipse at top, #1a0a1e 0%, #0D0D0D 60%)' }}
    >
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 pb-20 pt-8">
        {/* Page heading */}
        <h1 className="text-3xl md:text-4xl font-black tracking-tight ig-gradient-text inline-block mb-10">
          {title}
        </h1>

        {/* Page content */}
        <main>{children}</main>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-white/10 text-white/25 text-xs space-y-4">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            <Link to="/about" className="hover:text-white/60 transition-colors">About</Link>
            <span>·</span>
            <Link to="/privacy" className="hover:text-white/60 transition-colors">Privacy Policy</Link>
            <span>·</span>
            <Link to="/terms" className="hover:text-white/60 transition-colors">Terms of Service</Link>
            <span>·</span>
            <Link to="/contact" className="hover:text-white/60 transition-colors">Contact</Link>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            <Link to="/how-to-download-instagram-data" className="hover:text-white/60 transition-colors">
              How to Download Instagram Data
            </Link>
            <span>·</span>
            <Link to="/how-to-see-who-doesnt-follow-you-back" className="hover:text-white/60 transition-colors">
              Who's Not Following You Back
            </Link>
            <span>·</span>
            <Link to="/how-to-clean-up-your-following-list" className="hover:text-white/60 transition-colors">
              Clean Up Your Following List
            </Link>
            <span>·</span>
            <Link to="/best-free-instagram-unfollow-tracker" className="hover:text-white/60 transition-colors">
              Best Unfollow Tracker
            </Link>
            <span>·</span>
            <Link to="/why-instagram-third-party-apps-are-dangerous" className="hover:text-white/60 transition-colors">
              Why Apps Are Dangerous
            </Link>
            <span>·</span>
            <Link to="/how-to-improve-instagram-follower-ratio" className="hover:text-white/60 transition-colors">
              Improve Your Follower Ratio
            </Link>
            <span>·</span>
            <Link to="/instagram-account-audit" className="hover:text-white/60 transition-colors">
              Instagram Account Audit
            </Link>
            <span>·</span>
            <Link to="/what-is-a-good-follower-following-ratio" className="hover:text-white/60 transition-colors">
              Good Follower Ratio
            </Link>
          </div>
          <p className="text-center">© {new Date().getFullYear()} Purgr. Made with ♥</p>
        </footer>
      </div>
    </div>
  );
};

export default PageLayout;
